import type { texts } from "../../languages";
import type { InfoPageStyles } from "../../types";
import { Brightness1 } from "@mui/icons-material";
import { Box, List, ListItem, Typography, type Theme, type SxProps, ListItemAvatar } from "@mui/material";

export default function Instructions(props: {
  text: typeof texts.english;
  styles: Record<InfoPageStyles, SxProps<Theme>>;
}) {
  const { text, styles } = props;

  return (
    <Box>
      <List sx={styles.listBox}>
        <ListItem>
          <ListItemAvatar sx={styles.avatar}>
            <Brightness1 sx={styles.icon} />
          </ListItemAvatar>

          <Typography component="h6" variant="h6" sx={styles.text}>
            {text.insertEmailTitle}
          </Typography>
        </ListItem>

        <ListItem>
          <ListItemAvatar sx={styles.avatar}>
            <Brightness1 sx={styles.icon} />
          </ListItemAvatar>

          <Typography component="h6" variant="h6" sx={styles.text}>
            {text.agreeTermsNotice}
          </Typography>
        </ListItem>

        <ListItem>
          <ListItemAvatar sx={styles.avatar}>
            <Brightness1 sx={styles.icon} />
          </ListItemAvatar>

          <Typography component="h6" variant="h6" sx={styles.text}>
            {text.consentMsg}
          </Typography>
        </ListItem>
      </List>
    </Box>
  );
}
